import { shopperAgentStrategyIdFormat } from "@redotech/shopper-agent-strategy-id";
import * as z from "zod";

export const createShopperAgentStrategy = {
  name: "createShopperAgentStrategy" as const,
  input: z.object({}),
  output: z.object({ strategyId: shopperAgentStrategyIdFormat.schema }),
};
